module.exports = __webpack_public_path__ + "static/media/Hootsuite.5ce1f3b1.png";